// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0.0.36/static/js/" + chunkId + "." + "64fbb9de" + ".chunk.js";
};